import React from 'react';
import { useTheme } from '@mui/material/styles';

/**
 * Renders the Workflow86 logo with the correct asset for the current theme.
 * Uses MUI theme.palette.mode so the logo always matches the rendered UI.
 */
function ThemeLogo(props) {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const src = mode === 'dark' ? '/svgs/logo-dark.svg' : '/svgs/logo.svg';
  return <img src={src} alt="logo" {...props} />;
}

export default ThemeLogo;
